import React from "react";
import logo from "../img/css-logo.png";
//import Navbar from "./Navbar";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import { animateScroll as scroll } from "react-scroll";

const InnerHeader = () => {
//

  const toTop = () => {
    scroll.scrollToTop({ delay: 0, duration: 0 });
  };


  //assigning location variable
  const location = useLocation();
  
   //destructuring path name from location
   const {pathname} = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");


  //sticky header
  useEffect(() => {
    const selectHeader = document.querySelector("#header");
    if (selectHeader) {
      document.addEventListener("scroll", () => {
        window.scrollY > 80
          ? selectHeader.classList.add("sticked")
          : selectHeader.classList.remove("sticked");
      });
    }
  }, []);

  // mobile view menu
  const mobilemenu = (event) => {
    event.preventDefault();
    const mobileNavShow = document.querySelector(".mobile-nav-show");
    const mobileNavHide = document.querySelector(".mobile-nav-hide");
    mobileNavShow.classList.toggle("d-none");
    mobileNavHide.classList.toggle("d-none");
    document.querySelector("body").classList.toggle("mobile-nav-active");
  };

  
  return (
    <>
      <header style={{backgroundColor:'white'}} id="header" className="header fixed-top">
        <div style={{}} className="container-fluid container-xl d-flex align-items-center justify-content-between">
          <Link to="/" className="logo" onClick={toTop}>
            <img style={{width:'170px'}}
              src={logo}
              alt="Symbiotic Info tech Pvt. Ltd"
              title="Symbiotic Info tech Pvt. Ltd"
            />
          </Link>
          <span  onClick={mobilemenu} >  
          <i style={{color:'black'}} className="mobile-nav-toggle mobile-nav-show bi bi-list"     
          ></i>
          <i style={{color:'black'}}  className="mobile-nav-toggle mobile-nav-hide d-none bi bi-x"></i>
          </span>
          <nav id="navbar" className="navbar">
          <ul onClick={mobilemenu}>
            
            <li >
              <Link style={{color:'black' ,fontSize:'20px'}} to ="/"  className={splitLocation[1] === "" ? "active" : ""}> Home</Link>
            </li>

            <li>
            <Link style={{color:'black' ,fontSize:'20px'}} to ="/about"  className={splitLocation[1] === "about" ? "active" : ""}> About Us</Link>
            </li>

            <li>
            <Link style={{color:'black' ,fontSize:'20px'}} to ="/services"  className={splitLocation[1] === "services" ? "active" : ""}> Services</Link>
            </li>

            <li>
            <Link style={{color:'black' ,fontSize:'20px'}} to ="/gallery"  className={splitLocation[1] === "gallery" ? "active" : ""}> Gallery</Link>
            </li>

            <li>
            <Link style={{color:'black' ,fontSize:'20px'}} to ="/client"  className={splitLocation[1] === "client" ? "active" : ""}> Clients</Link>
            </li>
           
            <li>
            <Link style={{color:'black' ,fontSize:'20px',marginRight:'20px'}} to ="/contact"  className={splitLocation[1] === "contact" ? "active" : ""}> Contact Us</Link>
            </li>

            <li>
             
            <Link style={{color:'white' ,fontSize:'20px',paddingRight:'20px',backgroundColor:'rgb(217,56,49)'}} to="tel:+918197422345"  className="btn-get-started">
                  Call Us
                </Link>
                </li>
                <div style={{marginRight:'40px'}}></div>

             
               <li>
            <Link style={{color:'white' ,fontSize:'20px',paddingRight:'20px',backgroundColor:'rgb(217,56,49)'}} to="mailto:gopal@cssindia.co"  className="btn-get-started">
                  Email Us
                </Link>
                </li>
            
           


          </ul>
        </nav>
        </div>
      </header>
    </>
  );
};

export default InnerHeader;
